import { render, staticRenderFns } from "./feedailycheck.vue?vue&type=template&id=4af354d8&"
import script from "./feedailycheck.vue?vue&type=script&lang=js&"
export * from "./feedailycheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports